import mixpanel from "mixpanel-browser";
import { jsonDelete, jsonGet, jsonPost } from "../../api";

export async function getBulkCalls(page = 1, pageSize = 20) {
  return await jsonGet(`bulk?page=${page}&pageSize=${pageSize}`);
}

export async function getBulkDetails(id) {
  return await jsonGet(`bulk/${id}/details`);
}

export async function deleteBulkCall(id) {
  return await jsonDelete(`bulk/${id}`);
}

export async function sendLlmMessagesBulk(dto) {
  mixpanel.track("Bulk Messages Sent");
  return await jsonPost(`bulk`, dto);
}
